import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/icon_setting.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-basic" }
const _hoisted_3 = {
  key: 0,
  class: "top-row"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "nav-first" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/img/logo.png" })
], -1)
const _hoisted_6 = {
  class: "nav-second dropdown",
  style: {"z-index":"9999"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  ontouchstart: ""
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { style: {"text-align":"right","padding-left":"1em","padding-right":"1em","font-size":"0.8em"} }, "Ver. 1.0", -1)
const _hoisted_10 = {
  key: 1,
  class: "top-row"
}
const _hoisted_11 = { class: "nav-first" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "navbar-brand" }
const _hoisted_14 = { class: "nav-second" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$route.name == 'home')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item py-2",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.contact && _ctx.contact(...args)))
                  }, "お問い合わせ")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item py-2",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                  }, "初期化")
                ]),
                _hoisted_9
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.routeState.leftBtn != '' && _ctx.routeState.leftAction != null)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.routeState.leftAction && _ctx.routeState.leftAction(...args))),
                    ontouchstart: ""
                  }, [
                    _createElementVNode("img", {
                      src: '/img/' + _ctx.routeState.leftBtn + '.svg'
                    }, null, 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.routeState.title), 1),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.routeState.rightBtn != '' && _ctx.routeState.rightAction != null)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.routeState.rightAction && _ctx.routeState.rightAction(...args))),
                    ontouchstart: ""
                  }, [
                    _createElementVNode("img", {
                      src: '/img/' + _ctx.routeState.rightBtn + '.svg'
                    }, null, 8, _hoisted_15)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ]))
}